export const manager =[
  {
    title: '第一章 管理自我',
    cover: require('../images/lesson_chapter_1.png'),
    sections: [
      '结构思考：逻辑清晰有力表达',
      '卓有成效：管理者的五项修炼'
    ]
  },
  {
    title: '第二章 管理他人',
    cover: require('../images/lesson_chapter_2.png'),
    sections: [
      '辅导下属：教练型管理者',
      '向上管理：辅佐上司的报联商'
    ]
  },
  {
    title: '第三章 管理部门',
    cover: require('../images/lesson_chapter_3.png'),
    sections: [
      '难点突破：问题分析解决',
      '难点突破：问题分析解决'
    ]
  },
  {
    title: '第四章 管理业务',
    cover: require('../images/lesson_chapter_4.png'),
    sections: [
      '绩效改进：资源不变业绩翻倍',
      '绩效达成：OKR敏捷目标管理'
    ]
  },
  {
    title: '第五章 管理组织',
    cover: require('../images/lesson_chapter_5.png'),
    sections: [
      '组织变革：打通企业变革',
      '文化建设：做实企业文化'
    ]
  },
  {
    title: '进阶课程',
    cover: require('../images/lesson_chapter_6.png'),
    sections: [
      '行动教练之从胜任到卓越'
    ]
  }
]